import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NewWorkflowDialogComponent} from './new-workflow-dialog.component';
import {DialogModule} from "primeng/dialog";
import {InputModule} from "../../input/input.module";
import {ReactiveFormsModule} from "@angular/forms";


@NgModule({
  declarations: [
    NewWorkflowDialogComponent
  ],
  exports: [
    NewWorkflowDialogComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    InputModule,
    ReactiveFormsModule
  ]
})
export class NewWorkflowDialogModule {
}
